import { render, staticRenderFns } from "./lottery-popup-castrol.vue?vue&type=template&id=918468f8&scoped=true&"
import script from "./lottery-popup-castrol.vue?vue&type=script&lang=js&"
export * from "./lottery-popup-castrol.vue?vue&type=script&lang=js&"
import style0 from "./lottery-popup-castrol.vue?vue&type=style&index=0&id=918468f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918468f8",
  null
  
)

export default component.exports